<template>
    <el-dialog :visible.sync="repairListDialogVisible" @close="feedBack" v-if="repairListDialogVisible">
      <el-table style="font-size: 14px;" :data="repairRecordList.result.repairRecordList" height="300">
        <!--<el-table-column type="index"></el-table-column>-->
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="维修内容">
                <span>{{ props.row.repairContent }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="关联报修记录" prop="reportTitle" width="150"></el-table-column>
        <el-table-column label="维修警报点" prop="pointName" width="150"></el-table-column>
        <el-table-column label="维修人姓名" prop="repairerName" width="150"></el-table-column>
        <!--<el-table-column label="所属区域" prop="areaId" width="150"></el-table-column>-->
        <el-table-column label="是否解决" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.flag ? 'success':'error'">
              {{scope.row.flag ? '是':'否'}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="维修时间" prop="repairTime" width="150"></el-table-column>
        <el-table-column label="维修内容" prop="repairContent" width="auto"></el-table-column>
      </el-table>
      <el-pagination
        @current-change="getRepairRecordList(this.choosenReportRecordId)"
        background
        layout="prev, pager, next"
        :page-size="10"
        :total="totalCount1*10"
        :current-page.sync="GetRepairRecordList.params.pageNumber">
      </el-pagination>
<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button @click="feedBack">取 消</el-button>-->
<!--      </div>-->
    </el-dialog>
</template>

<script>
export default {
  name: 'RepairListDialog',
  props: ['repairListDialogVisible', 'repairRecordList'],
  data(){
    return {

    }
  },
  methods:{
    feedBack(){
      this.repairListDialogVisible = false;
      this.$emit('feedBack',this.repairListDialogVisible);
    },

  }
}
</script>

<style scoped>

</style>
